// extracted by mini-css-extract-plugin
var _1 = "webpack-components-shared-Pagination-Pagination-module__Pagination";
var _2 = "webpack-components-shared-Pagination-Pagination-module__Pagination_ellipsis";
var _3 = "webpack-components-shared-Pagination-Pagination-module__Pagination_item";
var _4 = "webpack-components-shared-Pagination-Pagination-module__Pagination_link";
export { _1 as "Pagination", _2 as "Pagination_ellipsis", _3 as "Pagination_item", _4 as "Pagination_link" }
